import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {ContattaciStyle} from "../../styles/pages/contact/ContattaciStyle";
import {
    Backdrop,
    Button,
    Checkbox,
    CircularProgress,
    DialogActions,
    DialogContentText,
    Divider,
    FormControlLabel,
    Menu,
    MenuItem,
    Paper,
    Typography
} from "@mui/material";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {BaseStyle} from "../../styles/shared/BaseStyle";
import clsx from 'clsx';
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import CustomSelect from "../widgets/inputs/CustomSelect";
import CustomMultiText from "../widgets/inputs/CustomMultiText";
import {bigNoteRegisterRequired} from "../../utils/RegisterUtils";
import {getCategoryByLabel, getSubcategoryByString} from "../../utils/GenericUtils";
import {generateTicket, resetAddTicket} from "../../services/TicketServices";
import {AppContext, CategoriesContext, TicketContext} from "../../App";
import {setCloseSnackbar, setLang, setOpenSnackbar, setThemeType} from "../../services/AppServices";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import IconButton from "@mui/material/IconButton";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import Tooltip from "@mui/material/Tooltip";
import FileInput from "../gestione/carico/utils/FileInput";
import {getTicketData} from "../../services/utils/TicketApiData";
import Copyright from "../auth/utils/Copyright";
import SimpleDialog from "../widgets/dialogs/SimpleDialog";
import {useTheme} from "@mui/styles";
import {AnagraficaTicket} from "../widgets/common/AnagraficaTicket";
import {langDict, languages} from "../../strings/LanguageDictionary";
import GTranslateTwoToneIcon from "@mui/icons-material/GTranslateTwoTone";
import DynamicFormExt from "../gestione/ticket/details/DynamicFormExt";
import useBackgroundImage from "../../styles/hooks/UseNewBackground";

const TicketPage = () => {
    const categoriesContext = useContext(CategoriesContext);
    let history = useHistory();
    const location = useLocation();
    const contattaciClasses = ContattaciStyle();
    const classes = BaseStyle();
    let theme = useTheme();
    let {categoria} = useParams();
    const selectedSubCategory = location.state?.sottoCategoria;
    const dynamicFormRef = useRef(null);

    const methods = useForm({
        mode: "onChange",
        defaultValues: {
            categoria: "", // Valore temporaneo fino a quando i dati sono disponibili
        }
    });
    const {setValue} = methods; // Estratto fuori dal useEffect


    const [submit, setSubmit] = useState(false);
    const ticketContext = useContext(TicketContext);
    const appContext = useContext(AppContext);
    const [openInformativa, setOpenInformativa] = useState(false);
    const [dynamicValues, setDynamicValues] = useState({});
    const [read, setRead] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    useBackgroundImage();


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (key) => {
        if (key) {
            setLang(key, appContext.dispatch)
        }
        setAnchorEl(null);
    };

    const handleCloseSnack = useCallback(() => {
        setCloseSnackbar(appContext.dispatch);
    }, [appContext.dispatch]);

    const onSubmit = useCallback((data) => {
        let res = true;
        if (dynamicFormRef.current) {
            res = dynamicFormRef.current.validateForm();
            console.log(res)
        }
        if (!res)
            return;

        if (data.categoria === "1") {
            if (data.allegato && data.allegato.length >= 1) {
                setSubmit(true);
                generateTicket(
                    getTicketData(
                        {...data, sendMail: !!data.email, contattoMail: !!data.email},
                        "Nuovo",
                        [],
                        [],
                        "EXT"),
                    ticketContext.dispatch)
            } else {
                setOpenSnackbar("warning", "Attenzione: è necessario allegare almeno un documento!", appContext.dispatch);
            }
        } else {
            let id = getSubcategoryByString(
                getCategoryByLabel(categoria, categoriesContext.categoriesV3)
                , methods.watch("sottoCategoria"))?.dynamicFormStructureId;

            setSubmit(true);
            generateTicket(
                getTicketData(
                    {
                        ...data, sendMail: !!data.email, contattoMail: !!data.email,
                        dynamicFormData: JSON.stringify(dynamicValues),
                        dynamicFormStructure: id !== 0 ? id : undefined,
                    },
                    "Nuovo",
                    [],
                    [],
                    "EXT"),
                ticketContext.dispatch)
        }
    }, [ticketContext.dispatch, appContext.dispatch, dynamicValues, categoria, categoriesContext.categoriesV3, methods])

    const handleFormDataChange = (data) => {
        setDynamicValues(data);
    };

    const goToHome = useCallback(() => {
        history.push("/contattaci");
    }, [history])

    const setCategoriaValue = useCallback(() => {
        if (categoriesContext.categoriesV3 && Object.entries(categoriesContext.categoriesV3).length > 0) {
            const category = getCategoryByLabel(categoria, categoriesContext.categoriesV3);
            const categoriaValue = category?.label || "";
            setValue("categoria", categoriaValue);

            if (selectedSubCategory && category?.subCategories && getSubcategoryByString(category, selectedSubCategory)) {
                setValue("sottoCategoria", selectedSubCategory, true);
            }
        }
    }, [categoria, categoriesContext.categoriesV3, selectedSubCategory, setValue]);

    useEffect(() => {
        setCategoriaValue();
    }, [setCategoriaValue]);

    useEffect(() => {
        if (!ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket === "") {
            setOpenSnackbar("success", "Ticket registrato con successo! Ora puoi chiudere questa scheda o continuare a consultare le FAQ", appContext.dispatch);
            setSubmit(false);
            resetAddTicket(ticketContext.dispatch);
            history.push("/contattaci");
        } else if (!ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket !== "") {
            setOpenSnackbar("error", ticketContext.state.errorAddTicket, appContext.dispatch);
            setSubmit(false);
        }
    }, [appContext.dispatch, ticketContext.state.loadingAddTicket, ticketContext.state.errorAddTicket, history, ticketContext.dispatch])

    useEffect(() => {
        setCloseSnackbar(appContext.dispatch);
    }, [appContext.dispatch])


    return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop} style={{zIndex: 6000}}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
            <main className={classes.mainNoBgCol}>
                <header className={contattaciClasses.header}>
                    <Tooltip
                        title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
                        <IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
                            {
                                appContext.state.theme.palette.mode === "light" ?
                                    <Brightness4TwoToneIcon/> :
                                    <Brightness5TwoToneIcon/>
                            }
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
                        <Button
                            className={contattaciClasses.translateButton}
                            color="inherit"
                            style={{
                                color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000",
                                borderRadius: 24
                            }}
                            onClick={handleClick}
                            startIcon={<GTranslateTwoToneIcon/>}
                        >
                            {languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
                        </Button>
                    </Tooltip>
                    <Menu
                        PaperProps={{
                            className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
                        }}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => handleClose()}
                    >
                        {
                            Object.entries(langDict).map(([key, val]) => {
                                return (
                                    <MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
                                        style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
                                )
                            })
                        }
                    </Menu>
                    <Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
                        <b>{languages[appContext.state.lang].CONTATTACI_OPEN_TICKET_TITLE_}</b>
                    </Typography>
                </header>
                <article className={contattaciClasses.article}>
                    <Paper
                        className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <FormProvider {...methods}>
                                <Grid container spacing={1}>
                                    <AnagraficaTicket classes={classes}
                                                      isCallReq={methods.watch("categoria") === "1" || methods.watch("categoria") === "3"}/>
                                    <Grid item xs={12}>
                                        <Divider style={{marginBottom: 20, marginTop: 20}}/>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography>
                                            <b>Seleziona una sotto categoria fra quelle disponibili:</b>
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <CustomSelect
                                            name={"categoria"}
                                            label={languages[appContext.state.lang].TICKET_SELECT_CATEGORY_LABEL_ + " *"}
                                            control={methods.control}
                                            defaultValue={""}
                                            autoFocus={false}
                                            none={true}
                                            noneValue={""}
                                            rules={{required: true}}
                                            disabled={true}
                                            error={methods.errors["categoria"]}
                                        >
                                            {Object.entries(categoriesContext.categoriesV3)
                                                .sort((a, b) => {
                                                    if (a["1"].label > b["1"].label) return 1;
                                                    if (a["1"].label < b["1"].label) return -1;
                                                    return 0
                                                })
                                                .map(([key, val]) => {
                                                    return (
                                                        <MenuItem value={val.label} key={val.label}>
                                                            {val.label}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </CustomSelect>
                                    </Grid>
                                    {
                                        methods.watch("categoria") && getCategoryByLabel(methods.watch("categoria"), categoriesContext.categoriesV3)?.subCategories?.length > 0 &&
                                        <Grid item xs={12}>
                                            <CustomSelect
                                                name={"sottoCategoria"}
                                                label={"Quale di queste sotto categorie? *"}
                                                control={methods.control}
                                                defaultValue={""}
                                                autoFocus={false}
                                                none={true}
                                                noneValue={""}
                                                rules={{required: true}}
                                                error={methods.errors["sottoCategoria"]}
                                            >
                                                {getCategoryByLabel(methods.watch("categoria"), categoriesContext.categoriesV3).subCategories.filter(val => val.enabled !== false && val.visible !== false).map((val, key) => {
                                                    return (
                                                        <MenuItem value={val.label} key={val.label}>
                                                            {val.label}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </CustomSelect>
                                        </Grid>
                                    }

                                    <Grid item xs={12}>
                                        <Divider style={{marginBottom: 20, marginTop: 20}}/>
                                    </Grid>

                                    {methods.watch("sottoCategoria") && getSubcategoryByString(
                                        getCategoryByLabel(categoria, categoriesContext.categoriesV3)
                                        , methods.watch("sottoCategoria"))?.dynamicFormStructureId !== 0 && (
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <DynamicFormExt
                                                    ref={dynamicFormRef}
                                                    dynamicFormStructureId={
                                                        getSubcategoryByString(
                                                            getCategoryByLabel(categoria, categoriesContext.categoriesV3)
                                                            , methods.watch("sottoCategoria"))?.dynamicFormStructureId
                                                    }
                                                    clienteCensito={false}
                                                    onDataChange={handleFormDataChange}
                                                    categoria={methods.watch("sottoCategoria")}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                        </React.Fragment>)}


                                    <Grid item xs={12}>
                                        <CustomMultiText
                                            inputRef={methods.register(bigNoteRegisterRequired)}
                                            name={"dettaglioRichiesta"}
                                            label={languages[appContext.state.lang].TICKET_MESSAGGIO_DEL_TICKET__ + " *"}
                                            autoFocus={false}
                                            error={methods.errors["dettaglioRichiesta"]}
                                            rows={10}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FileInput name={"allegato"} multiple={true} accept={"*"}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography color={"textSecondary"}>
                                            {languages[appContext.state.lang].CONTATTACI_INFO_TICKT_RESPONSE}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
                                        <Button variant={"contained"} color={"primary"} disableElevation
                                                className={classes.roundButton}
                                                onClick={methods.handleSubmit(onSubmit)} disabled={submit}
                                                style={{fontSize: 18, borderRadius: 24}}>
                                            <b>{languages[appContext.state.lang].CONTATTACI_OPEN_TICKET_TITLE_}</b>
                                        </Button>
                                    </Grid>

                                </Grid>
                            </FormProvider>
                        </form>
                    </Paper>
                    <Button className={clsx(classes.roundBorder, classes.margin2, classes.blurred20)}
                            style={{borderRadius: 24}}
                            size={"small"} variant={"contained"} color={"primary"}
                            startIcon={<ArrowBackTwoToneIcon/>} onClick={goToHome}>
                        {languages[appContext.state.lang].CONTATTACI_RETURN_HOME_BUTTON}
                    </Button>
                </article>
                <footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
                    <Copyright/>
                </footer>
            </main>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
                <Alert style={{borderRadius: 28}} onClose={handleCloseSnack}
                       severity={appContext.state.severity}>
                    {appContext.state.message}
                </Alert>
            </Snackbar>
            <SimpleDialog
                open={openInformativa}
                customFullScreen={true}
                title={languages[appContext.state.lang].CONTATTACI__BENVENUTO__TITLE_}
                content={
                    <DialogContentText component={"div"}>
                        {languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIVACY}
                        <a style={{color: theme.palette.primary.main}}
                           href={"http://www.aslcittaditorino.it/privacy/"}
                           target="_blank"
                           rel="noopener noreferrer">{
                            "http://www.aslcittaditorino.it/privacy/"
                        }</a> {languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIV_2_}.<br/>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color={"primary"}
                                    checked={read}
                                    onChange={() => setRead(!read)}
                                    name="read"/>
                            }
                            label={languages[appContext.state.lang].CONTATTACI_READ_CONFIRM_PRIV_}
                        />
                    </DialogContentText>
                }
                actions={
                    <DialogActions>
                        <Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
                            <Button
                                color="inherit"
                                style={{
                                    color: appContext.state.theme.palette.mode === "light" ? "#000" : "#FFF",
                                    borderRadius: 24
                                }}
                                onClick={handleClick}
                                startIcon={<GTranslateTwoToneIcon/>}
                            >
                                {languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
                            </Button>
                        </Tooltip>
                        <Menu
                            PaperProps={{
                                className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
                            }}
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={() => handleClose()}
                        >
                            {
                                Object.entries(langDict).map(([key, val]) => {
                                    return (
                                        <MenuItem style={{width: 300}} key={key}
                                                  onClick={() => handleClose(key)}>{val.flag}<span
                                            style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
                                    )
                                })
                            }
                        </Menu>
                        <Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
                                color={"primary"} style={{borderRadius: 24}}
                                onClick={() => setOpenInformativa(false)} disabled={!read}>
                            <b>{languages[appContext.state.lang].CONTATTACI__CONFERMO_PRIVACY_}</b>
                        </Button>
                    </DialogActions>
                }
            />
        </React.Fragment>
    );
};

function Alert(props) {
    return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(TicketPage);
